import PageHero from '@/components/PageHero'
import SEOHead from '@/components/SEOHead'

function Terms() {
  return (
    <div>
      <SEOHead
        title="Terms of Service"
        description="Review the AdsROAS Calculator terms of service governing the use of our free advertising ROAS, ROI, and ACoS calculators."
      />

      <PageHero
        eyebrow="Legal"
        title="Terms of Service"
        description="Last updated: January 2025. The terms that govern use of AdsROAS Calculator's free advertising tools."
        compact
      />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14">
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-8 text-slate-600 leading-relaxed shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">1. Acceptance of Terms</h2>
            <p>
              By accessing or using www.adsroascalculator.com (the "Service"), you agree to be bound by these
              Terms of Service. If you do not agree to these terms, please do not use the Service.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">2. Description of Service</h2>
            <p>
              AdsROAS Calculator provides free, informational tools to help estimate Return on Ad Spend (ROAS),
              Return on Investment (ROI), break-even points, and related advertising metrics for platforms such
              as Google Ads, Facebook Ads, and Amazon Advertising. The Service is provided "as is" for
              informational and planning purposes only.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">3. No Financial or Professional Advice</h2>
            <p>
              Calculations produced by our tools are estimates based on the values you provide and standard
              marketing formulas. They do not constitute financial, tax, legal, or professional advertising
              advice. You are solely responsible for decisions made using our calculators.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">4. No Warranty</h2>
            <p>
              We make reasonable efforts to ensure calculation accuracy, but we make no warranties, express or
              implied, regarding the accuracy, reliability, or completeness of any output produced by the
              Service. Use of the calculators is at your own risk.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">5. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, AdsROAS Calculator and its operators shall not be liable
              for any direct, indirect, incidental, or consequential damages arising from your use of, or
              inability to use, the Service, including any advertising or business decisions made based on
              calculator outputs.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">6. Independence from Advertising Platforms</h2>
            <p>
              AdsROAS Calculator is an independent tool and is not affiliated with, endorsed by, or sponsored by
              Google, Meta, Amazon, or any other advertising platform referenced on this Service. All trademarks
              belong to their respective owners.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">7. Intellectual Property</h2>
            <p>
              All content, branding, and design on the Service are the property of AdsROAS Calculator unless
              otherwise noted. You may not reproduce, redistribute, or resell the Service or its content without
              permission.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">8. Changes to These Terms</h2>
            <p>
              We reserve the right to modify these Terms of Service at any time. Continued use of the Service
              after changes are posted constitutes acceptance of the revised terms.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-2">9. Contact</h2>
            <p>
              For questions about these Terms of Service, please reach out via our{' '}
              <span className="font-medium text-slate-900">Contact</span> page.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Terms
